<template>
        <stats-card :title="title"
                    :type="'gradient-'+type"
                    :sub-title="annualVolume.toString()"
                    :icon="showHeader ? '' : 'fad fa-layer-group'"
                    class="mb-4 mb-xl-0">
            <template v-slot:header v-if="showHeader">
                <router-link :to="{ name: 'Verträge' }" class="router-link">
                    <div class="row align-items-center">
                        <div class="col">
                            <h6 class="text-uppercase text-muted ls-1 mb-1">CRM</h6>
                        </div>
                        <div class="col-auto">
                            <div class="icon icon-shape"><i class="fad fa-balance-scale text-danger" aria-hidden="true"></i></div>
                        </div>
                    </div>
                    <hr class="mb-3 mt-1">
                </router-link>
            </template>
                <span v-if="error.length > 0" class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
            <template v-slot:footer></template>
        </stats-card>
</template>
<script>
import {ref, onMounted} from 'vue';
import UserService from '@/services/user.service';
import moment from 'moment';

export default {
    name: 'ContractVolume',
    components: {},
    props: {
        type: {
            type: String,
            default: "green"
        },
        title: {
            type: String,
            default: "Vertragsvolumen aktuelles Jahr"
        },
        showHeader: {
            type: Boolean,
            default: false
        }
    },
    setup() {

        const error = ref('');

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }


        const annualVolume = ref(0.0);

        function getContracts() {
            UserService.getContracts().then(
                response => {
                    response.data.data.map(contract => {
                            if(moment(contract.endDate, 'DD.MM.YYYY').format('YYYY') === moment().format('YYYY')) {
                                annualVolume.value += parseFloat(contract.amount);
                            }
                    });
                    annualVolume.value = parseFloat(annualVolume.value).toLocaleString('de-CH', {
                        style: 'currency',
                        currency: 'CHF'
                    })
                    error.value = '';
                },
                error => {
                    getError(error);
                }
            );
        }

        onMounted(() => {
            getContracts();
        });

        return {
            error,
            annualVolume,
        }
    }
}
</script>

<style lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}
</style>
